import React from 'react';
import { useLocation } from 'react-router-dom';
import { isApp } from '../../utils/isApp';
import NoticePopup from './NoticePopup';

/**
 * 관문 미적용 경로.
 * 로그인 전이거나 401 자체가 안 나는 공개 화면 — 여기서 막으면 로그인·QR 진입이 불가능해진다.
 * router.js 의 실제 path 와 1:1 대응하므로 라우트를 추가/변경하면 여기도 함께 본다.
 */
function isExemptPath(pathname, inApp) {
  // 로그인 — router.js '/'(:38) '/login'(:40) '/mobile/login*'(:77,:80,:82,:86) '/admin/login/*'(:67,:71)
  if (pathname === '/' || pathname === '') return true;
  if (pathname === '/login') return true;
  if (pathname.startsWith('/mobile/login')) return true;
  if (pathname.startsWith('/admin/login')) return true;

  // QR 진입 — 역매핑 전에 막으면 목적지가 유실된다. 목적지 화면에서 관문이 잡는다.
  //  router.js '/app/qr/:type/:uuid'(:114) '/app/link/:type/:uuid'(:117)
  if (pathname.startsWith('/app/')) return true;

  // 공개 화면 — 로그인 없이 동작하므로 조회가 401 이라 팝업을 띄울 수 없다.
  //  router.js '/store-guide'(:42) '/popup/*'(:44) '/mobile/verifyinvalid'(:111)
  if (pathname === '/store-guide') return true;
  if (pathname.startsWith('/popup/')) return true;
  if (pathname === '/mobile/verifyinvalid') return true;

  // 앱 전용 화면 — 웹은 AppOnlyGuard 가 차단하므로 팝업 조회가 401 이다.
  //  앱은 정상 경로이므로 공지를 그대로 띄운다.
  //  router.js '/mobile/verifysuccess/:storeNo/:memberGiftNo/:giftNo'(:103)
  if (!inApp && pathname.startsWith('/mobile/verifysuccess')) return true;

  return false;
}

/**
 * 공지 관문. App.js 의 <Router /> 한 곳을 감싸 36개 라우트를 전부 커버한다
 * (router.js 는 중첩 라우트가 없어 개별 적용은 36곳 중복이 된다).
 * 필수 공지 → 일반 공지 순으로 NoticePopup 이 처리하고, 끝나면 children 을 렌더한다.
 *
 * ★'./NoticePopup' 의 default export 는 NoticePopupBoundary 다(NoticePopup.js:357).
 *   렌더 예외 시 children 을 통과시켜(fail-open) 화면이 백지가 되지 않는다.
 */
export default function RequiredNoticeGuard({ children }) {
  const { pathname } = useLocation();
  if (isExemptPath(pathname, isApp())) {
    return <>{children}</>;
  }
  return <NoticePopup>{children}</NoticePopup>;
}
